<template>
  <hm-content title="订单列表">
    <div class="table-panel flex item-center">
      <el-select
        clearable
        v-model="serverId"
        placeholder="选择服务"
        size="small"
        filterable
        class="mr10"
      >
        <el-option
          v-for="item in serviceList.list"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="dateAndTime"
        type="datetimerange"
        size="small"
        class="mr10"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['12:00:00']"
      ></el-date-picker>
      <el-input
        clearable
        v-model.trim="orderId"
        placeholder="输入订单号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-input
        clearable
        v-model.trim="realName"
        placeholder="输入会员姓名"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="success" size="small" @click="output">导出</el-button>
    </div>
    <div class="order-list table">
      <el-table
        stripe
        border
        @row-click="toDetail"
        :data="orderList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderId"
          label="订单号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="addTimeFormat"
          width="140px"
          label="下单时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payTimeFormat"
          width="140px"
          label="付款时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totPrice"
          label="总金额"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payPrice"
          label="实付金额"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeOutlet"
          label="指定门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverName"
          label="所属服务"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="statusFormat"
          label="订单状态"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payTypeFormat"
          label="支付方式"
        ></el-table-column>
        <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="toDetail(scope.row.id)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="orderList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="订单详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <ul class="order-detail-list">
        <li>
          <h3 class="title">订单信息</h3>
          <div class="details">
            <div class="item">
              <span>订单状态：</span>
              {{ orderDetail.orderInfo.statusFormat }}
            </div>
            <div class="item">
              <span>订单号：</span>
              {{ orderDetail.orderInfo.orderId }}
            </div>
            <div class="item">
              <span>下单时间：</span>
              {{ orderDetail.orderInfo.addTimeFormat }}
            </div>
            <div class="item">
              <span>付款时间：</span>
              {{ orderDetail.orderInfo.payTimeFormat }}
            </div>
            <div class="item">
              <span>支付方式：</span>
              {{ orderDetail.orderInfo.payTypeFormat }}
            </div>
          </div>
        </li>
        <li v-if="orderDetail.productInfo.length">
          <h3 class="title">服务卡信息</h3>
          <dl class="order-table">
            <dt class="order-header flex">
              <span>服务卡名称</span>
              <span>价格</span>
              <span>购买数量</span>
              <span>小计</span>
            </dt>
            <dd
              class="order-item flex"
              v-for="(v, i) in orderDetail.productInfo"
              :key="i"
            >
              <span>{{ v.productName }}</span>
              <span>{{ v.unitPrice }}</span>
              <span>{{ v.productNum }}</span>
              <span>{{ v.unitPrice * v.productNum }}</span>
            </dd>
          </dl>
        </li>
        <li>
          <h3 class="title">费用信息</h3>
          <div class="item" style="color: #e50065">
            <span>商品总金额：</span>
            ￥{{ orderDetail.priceInfo.totPrice }}
          </div>
        </li>
        <li>
          <h3 class="title">下单人信息</h3>
          <div class="details">
            <div class="item">
              <span>会员姓名：</span>
              {{ orderDetail.memberInfo.realName }}
            </div>
            <div class="item">
              <span>用户手机号：</span>
              {{ orderDetail.memberInfo.mobilePhone }}
            </div>
            <div class="item">
              <span>下单门店：</span>
              {{ orderDetail.memberInfo.storeOutlet }}
            </div>
            <div class="item">
              <span>预约技师：</span>
              {{ orderDetail.memberInfo.guiderName }}
            </div>
            <div class="item">
              <span>工号：</span>
              {{ orderDetail.memberInfo.workNum }}
            </div>
          </div>
        </li>
      </ul>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="back">返回</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import axios from "axios";

import moment from "moment";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dialogVisible: false,
      currentId: "",
      total: 100,
      currentPage: 1,
      pageSize: 10,
      orderId: "",
      realName: "",
      serverId: "",
      dateAndTime: "",
      startDate: "",
      endDate: ""
    };
  },
  mounted() {
    this.queryList();
    this.$store.dispatch("queryServiceList", { pageSize: 999 });
  },
  computed: mapGetters(["orderList", "serviceList", "orderDetail"]),
  watch: {
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryOrderList", {
        orderId: this.orderId,
        realName: this.realName,
        serverId: this.serverId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    toDetail(row) {
      this.dialogVisible = true;
      this.$store.dispatch("queryOrderDetail", { orderId: row.orderId });
    },
    back() {
      this.dialogVisible = false;
    },
    output() {
      axios({
        method: "post",
        url: `/server-back/order_export`,
        data: {
          orderId: this.orderId,
          realName: this.realName,
          serverId: this.serverId,
          startDate: this.startDate,
          endDate: this.endDate
        },
        responseType: "arraybuffer"
      }).then(res => {
        this.download(res.data);
      });
      // axios.post(`${adress}/server-back/order_export`, {});
      // this.$store.dispatch("outputOrder", {
      //   orderId: this.orderId,
      //   realName: this.realName,
      //   serverId: this.serverId,
      //   startDate: this.startDate,
      //   endDate: this.endDate
      // });
    },
    download(data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "订单列表.xlsx");
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>

<style scoped lang="scss">
.order-detail-list {
  li {
    margin-bottom: 30px;
    font-size: 14px;
  }
  .title {
    font-size: 16px;
    margin: 0;
    margin-bottom: 10px;
  }
  .item {
    line-height: 28px;
    span {
      color: #999;
    }
  }
  .order-table {
    border: 1px solid #ebebeb;
    margin-top: 12px;
    max-width: 500px;
    .order-header {
      border-bottom: 1px solid #ebebeb;
      background: #f5f7fa;
    }
    span {
      padding: 12px;
      width: 25%;
      text-align: center;
      border-right: 1px solid #ebebeb;
    }
    span:last-child {
      border-right: none;
    }
  }
}
</style>
